export class InvoiceImportModel {
  counter: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  bussinessDocumentsClassId: number = 0;
  bussinessDocumentsTypeCode: number = 0;
  invoiceConsecutive: number = 0;
  isChargeAccount: boolean = false;
  dateInvoice: Date = new Date;
  dateExpiration: Date = new Date;
  clientDocument: string = "";
  clientDocument2: string | null = null;
  costCenterCode: number | null = null;
  sellerDocument: string | null = null;
  cufe: string | null = null;
  swSelfRetainer: boolean = false;
  swIcaSelfRetainer: boolean = false;
  subtotalValue: number = 0;
  discountValue: number = 0;
  ivaValue: number = 0;
  totalValue: number = 0;
  reteIvaValue: number = 0;
  reteFuenteValue: number = 0;
  reteIcaValue: number = 0;
  valueToPay: number = 0;
  paymentValue: number = 0;
  debitNotesValue: number = 0;
  creditNotesValue: number = 0
  residueValue: number = 0;
  updateDetails: boolean = false;
  conceptInvoicingCode: number | null = null;
  invoiceWalletTypeCode: number | null = null;
  storeCode: number | null = null;
  valueConcept: number | null = null;
  ivaValueConcept: number | null = null;
  reteFuenteValueConcept: number | null = null;
  reteIcaValueConcept: number | null = null;
  discountValueConcept: number | null = null;
  debitNotesValueConcept: number | null = null;
  creditNotesValueConcept: number | null = null;
  articleId: number | null = null;
  updateInvoicesZero: boolean = false;
  dateInvoicePdf: Date | null = null;
  dateInvoiceSend: Date | null = null;

  constructor(counter: number,
    companyId: number,
    branchId: number,
    enterpriseId: number,
    bussinessDocumentsClassId: number,
    bussinessDocumentsTypeCode: number,
    invoiceConsecutive: number,
    dateInvoice: Date,
    dateExpiration: Date,
    invoiceWalletTypeCode: number | null,
    clientDocument: string,
    clientDocument2: string | null,
    costCenterCode: number | null,
    sellerDocument: string | null,
    cufe: string | null,
    swSelfRetainer: boolean,
    swIcaSelfRetainer: boolean,
    subtotalValue: number,
    discountValue: number,
    ivaValue: number,
    totalValue: number,
    reteIvaValue: number,
    reteFuenteValue: number,
    reteIcaValue: number,
    valueToPay: number,
    paymentValue: number,
    debitNotesValue: number,
    creditNotesValue: number,
    residueValue: number,
    updateDetails: boolean,
    conceptInvoicingCode: number | null,
    storeCode: number | null,
    valueConcept: number | null,
    ivaValueConcept: number | null,
    reteFuenteValueConcept: number | null,
    reteIcaValueConcept: number | null,
    discountValueConcept: number | null,
    debitNotesValueConcept: number | null,
    creditNotesValueConcept: number | null,
    articleId: number | null,
    updateInvoicesZero: boolean,
    dateInvoicePdf: Date | null,
    dateInvoiceSend: Date | null) {
    this.counter = counter;
    this.companyId = companyId;
    this.branchId = branchId;
    this.enterpriseId = enterpriseId;
    this.bussinessDocumentsClassId = bussinessDocumentsClassId;
    this.bussinessDocumentsTypeCode = bussinessDocumentsTypeCode;
    this.invoiceConsecutive = invoiceConsecutive;
    this.dateInvoice = dateInvoice;
    this.dateExpiration = dateExpiration;
    this.invoiceWalletTypeCode = invoiceWalletTypeCode;
    this.clientDocument = clientDocument;
    this.clientDocument2 = clientDocument2;
    this.costCenterCode = costCenterCode;
    this.sellerDocument = sellerDocument;
    this.cufe = cufe;
    this.swSelfRetainer = swSelfRetainer;
    this.swIcaSelfRetainer = swIcaSelfRetainer;
    this.subtotalValue = subtotalValue;
    this.discountValue = discountValue;
    this.ivaValue = ivaValue;
    this.totalValue = totalValue;
    this.reteIvaValue = reteIvaValue;
    this.reteFuenteValue = reteFuenteValue;
    this.reteIcaValue = reteIcaValue;
    this.valueToPay = valueToPay;
    this.paymentValue = paymentValue;
    this.debitNotesValue = debitNotesValue;
    this.creditNotesValue = creditNotesValue;
    this.residueValue = residueValue;
    this.updateDetails = updateDetails;
    this.conceptInvoicingCode = conceptInvoicingCode;
    this.storeCode = storeCode;
    this.valueConcept = valueConcept;
    this.ivaValueConcept = ivaValueConcept;
    this.reteFuenteValueConcept = reteFuenteValueConcept;
    this.reteIcaValueConcept = reteIcaValueConcept;
    this.discountValueConcept = discountValueConcept;
    this.debitNotesValueConcept = debitNotesValueConcept;
    this.creditNotesValueConcept = creditNotesValueConcept;
    this.articleId = articleId;
    this.updateInvoicesZero = updateInvoicesZero;
    this.dateInvoicePdf = dateInvoicePdf;
    this.dateInvoiceSend = dateInvoiceSend;
  }
}